<template>
	<div>
		<template v-if="newTickets.length">
			<Ticket :ticket="t" v-for="t in newTickets" :key="t.id" />
			<uiDevider />
		</template>
		<template v-if="opened.length">
			<Ticket :ticket="t" v-for="t in opened" :key="t.id" />
			<uiDevider />
		</template>
		<Ticket :ticket="t" v-for="t in closed" :key="t.id" />
	</div>
</template>

<script>
import Ticket from '@/components/Ticket'

export default {
	name: 'TicketList',
	components: {
		Ticket,
	},
	props: {
		tickets: Array,
	},
	computed: {
		newTickets() {
			return this.tickets.filter((t) => !t.assigned)
		},
		opened() {
			return this.tickets.filter((t) => t.assigned && !t.closed)
		},
		closed() {
			return this.tickets.filter((t) => t.assigned && t.closed)
		},
	},
}
</script>

<style lang="less" scoped>
@import '../assets/app.less';

.ticket {
	margin-bottom: 20px;

	&.assigned {
		cursor: pointer;
	}

	.header {
		display: flex;
		align-items: center;
	}

	.icon {
		height: 40px;
	}

	.right {
		margin-left: 10px;
	}

	.name {
		font-size: 15px;
		font-weight: bold;
		margin-bottom: 2px;
	}

	.info {
		color: @red;
		font-size: 12px;
		font-weight: bold;

		&.assigned {
			color: @accent;
		}

		span {
			opacity: 0.5;
			color: #000;
			font-weight: normal;
		}
	}

	.text {
		margin: 10px 0;
		font-size: 15px;
		opacity: 0.5;
	}
}
</style>
